import type { FaqAccordionControllerProps } from '@application/components';
import { FaqAccordionController, SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { FaqPage } from '@presentation/pages';
import type { FC } from 'react';

interface FaqPageControllerProps extends Pick<FaqAccordionControllerProps, 'resource'> {}

export const FaqPageController: FC<FaqPageControllerProps> = (props) => {
  const { resource } = props;
  const { translate } = useRouter();
  const seoTitle = translate(`faq.${resource}.seo.title`);
  const seoDescription = translate(`faq.${resource}.seo.description`);

  return (
    <>
      <SeoController title={seoTitle} description={seoDescription} />
      <FaqPage
        resource={resource}
        accordionComponent={<FaqAccordionController resource={resource} />}
      />
    </>
  );
};
